import { formatDateTime } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";
import { capitalize } from "@mui/material";
import { utcToZonedTime } from "date-fns-tz";

import { type GetReferralsResponse } from "../../api/useGetReferrals";
import { BaseReferralStatusCard } from "./BaseReferralStatusCard";

interface PendingReferralCardProps {
  referral: GetReferralsResponse[0];
  timezone: string;
}

export function PendingReferralCard(props: PendingReferralCardProps) {
  const { referral, timezone } = props;
  const { bonusValue, bonusRequirementMessage, referrerName, expiresAt } = referral;

  const expiresAtZoned = isDefined(expiresAt) ? utcToZonedTime(expiresAt, timezone) : undefined;
  const expiresAtFormatted = isDefined(expiresAtZoned)
    ? `by ${formatDateTime(expiresAtZoned)}`
    : undefined;

  const description = `${capitalize(
    bonusRequirementMessage ?? "work your first shift"
  )} ${expiresAtFormatted} to earn a $${bonusValue} bonus.`;

  return (
    <BaseReferralStatusCard
      intent="neutral"
      icon="gift-lavender-colored"
      title={`You have an active referral from ${referrerName}.`}
      description={description}
    />
  );
}
